/* eslint-disable react-hooks/exhaustive-deps */
import { compressAccurately } from "image-conversion";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { FaPencilAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import getUsersCities from "../../Hooks/getUsersCities";
import { toggleLoading } from "../../Redux/reducers/loadingSlice";
import { changeUser } from "../../Redux/reducers/userSlice";
import { checkAuth } from "../../Utils/CheckAuthentication";
import { TOKEN_KEY } from "../../Utils/Constants";
import DataURIToBlob from "../../Utils/DataURIToBlob";
import { baseUrl } from "../../shared/baseUrl";
import { createNotification } from "../Common/CreateNotification";
import NotLoggedIn from "../Common/NotLoggedIn";
import NotVerified from "../Common/NotVerified";
import ChangePassword from "../Navbar/Auth/ChangePassword";
import EditProfile from "../Navbar/Auth/EditProfile";
import AddProduct from "./AddProduct";
import ImageCropper from "./ImageCropper";
import AllProducts from "./UserProducts/AllProducts";
import UserShareBtn from "./UserShareBtn";
import "./Users.css";

const MyAccount = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const [imageCropperOpen, setImageCropperOpen] = useState(false);
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [isEditProfile, setIsEditProfile] = useState(false);
  const getUser = async () => {
    if (user !== null) {
      await fetch(baseUrl + "get-user-details", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization:
            localStorage.getItem(TOKEN_KEY) !== null
              ? "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
              : null,
        },
      })
        .then((res) => checkAuth(res))
        .then((res) => {
          if (res.success) {
            dispatch(changeUser(res.user));
          } else {
            createNotification("error", res.message);
          }
        })
        .catch((e) => {
          createNotification("error", e.message);
        });
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  const apply = (file) => {
    dispatch(toggleLoading(true));
    compressAccurately(DataURIToBlob(file), 200).then((res) => {
      uploadImage(res);
    });
  };

  const uploadImage = async (file) => {
    setImageCropperOpen(false);
    dispatch(toggleLoading(true));
    var formdata = new FormData();
    formdata.append("file", file);
    await fetch(baseUrl + "upload-profile-image", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token,
      },
      body: formdata,
    })
      .then((res) => checkAuth(res))
      .then((res) => {
        if (res.success) {
          createNotification("success", res.message);
          var avatarChanged = JSON.parse(localStorage.getItem(TOKEN_KEY));
          avatarChanged.avatar = res.image;
          localStorage.setItem(TOKEN_KEY, JSON.stringify(avatarChanged));
          dispatch(changeUser(avatarChanged));
          dispatch(toggleLoading(false));
        } else {
          dispatch(toggleLoading(false));
          createNotification("error", res.message);
        }
      })
      .catch((e) => {
        dispatch(toggleLoading(false));
        createNotification("error", e.message);
      });
  };

  return (
    <>
      {user !== null ? (
        <div style={{ overflowX: "hidden" }}>
          <Helmet>
            <title>{user.name} - Account - Thrift Store Nepal</title>
            <meta
              name="description"
              content="User - Thrift Store Nepal - Search for your best matching thrift item according to different category and criteria. Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal)"
            />
            <meta
              property="og:title"
              content={`${user.name} - Account - Thrift Store Nepal`}
            />
            <meta
              property="og:description"
              content="User - Thrift Store Nepal - Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - THrift Store Nepal (Thrift Shop Nepal)"
            />
            {/* <meta name="og:image" content="/assets/images/og-2.png" /> */}
          </Helmet>
          <div className={"head-banner"}>
            <img
              alt="first"
              className={"banner-img"}
              src="/assets/images/first.png"
            />
            <div className={"logo-div"}>
              <img
                alt="avatar"
                className="logo-img"
                style={{ objectFit: "cover" }}
                src={
                  user.avatar ??
                  "https://ui-avatars.com/api/?background=ec008c&color=ffffff&name=" +
                  user.name
                }
              />
              <div
                onClick={() => {
                  setImageCropperOpen(true);
                }}
                className="d-flex justify-content-center align-content-center cursor-pointer"
                style={{
                  position: "absolute",
                  bottom: 0,
                  right: 10,
                  background: "#00000090",
                  height: "5vh",
                  width: "5vh",
                  borderRadius: 25,
                }}
              >
                <FaPencilAlt
                  className="img-edit-icon my-auto"
                  style={{ color: "White" }}
                  size={"2.5vh"}
                />
              </div>
            </div>
          </div>

          <div className={"user-section d-flex justify-content-center"}>
            <div className="text-center">
              <div>
                <div
                  className={
                    "d-flex justify-content-center align-content-center"
                  }
                >
                  <button
                    onClick={() => {
                      setIsEditProfile(true);
                    }}
                    className="thrift-btn me-1"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => {
                      setIsChangePassword(true);
                    }}
                    className="thrift-btn ms-1"
                  >
                    Change Password
                  </button>
                </div>
              </div>
              <p className="lead fw-bold mb-0">{user.name}</p>
              <p className="m-0 p-0">{user.email}</p>
              <p className="m-0 p-0">{user.city}</p>
              <p className="m-0 p-0">{user.contact}</p>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-2 flex-wrap">

            <UserShareBtn userName={user.name}
              userID={user.id} />
          </div>
          <ImageCropper
            imageSelectModal={imageCropperOpen}
            setImageSelectModal={setImageCropperOpen}
            apply={apply}
          />
          <ChangePassword
            isOpen={isChangePassword}
            onClose={() => {
              setIsChangePassword(false);
            }}
          />
          <EditProfile
            isOpen={isEditProfile}
            onClose={() => {
              setIsEditProfile(false);
            }}
            user={user}
          />
          {user.is_verified ? <VerifiedContent /> : <NotVerified />}
        </div>
      ) : (
        <>
          <Helmet>
            <title>{`User - Account - Thrift Store Nepal`}</title>
            <meta
              name="description"
              content="User - Thrift Store Nepal - Search for your best matching thrift item according to different category and criteria. Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal)"
            />
            <meta
              property="og:title"
              content={`User - Account - Thrift Store Nepal`}
            />
            <meta
              property="og:description"
              content="User - Thrift Store Nepal - Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - THrift Store Nepal (Thrift Shop Nepal)"
            />
            <meta name="og:image" content="/assets/images/og-2.png" />
          </Helmet>
          <NotLoggedIn />
        </>
      )}
    </>
  );
};

export default MyAccount;

const VerifiedContent = () => {

  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [cityOption, setCityOption] = useState("");
  const [categoryOption, setCategoryOption] = useState("");
  const [uploadedImages, setUploadedImages] = useState([]);
  const [isProductAdded, setIsProductAdded] = useState("");
  const [totalItems, setTotalItems] = useState({
    approved: 0,
    pending: 0,
    rejected: 0,
  });
  useEffect(() => {
    const init = async () => {
      const userCities = await getUsersCities();
      setCityOption(userCities);
      getCategories();
      fetchUploadedImages();
    };

    init();
  }, []);

  const getCategories = async () => {
    await fetch(baseUrl + "all-categories")
      .then((res) => res.json())
      .then((res) => {
        setCategoryOption(res.data);
      })
      .catch((e) => console.log(e.message));
  };

  const fetchUploadedImages = () => {
    fetch(baseUrl + "uploaded-images", {
      method: "POST",
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token,
      },
    })
      .then((res) => checkAuth(res))
      .then((res) => {
        if (res.success) {
          setUploadedImages(res.images);
        } else {
          createNotification("error", "Failed to get uploaded images");
        }
      })
      .catch((err) => {
        createNotification("error", "Failed to get uploaded images");
      });
  };

  return (
    <div className="col-12 container mt-3">
      <div className="col-12 d-flex flex-wrap justify-content-between">
        <h4 className="my-auto">My Items: </h4>
        <button
          onClick={() => {
            setOpenAddProduct(true);
          }}
          className=" thrift-btn text-light"
          style={{ background: "#ec008c" }}
        >
          + Add Product
        </button>
      </div>
      <div className="p-0 my-3">
        <div>
          <Nav className="d-flex justify-content-start" tabs>
            {/* <NavItem className="cursor-pointer active" onClick={() => { setActiveTab('1'); }}>
                            <NavLink style={{ color: activeTab !== "1" ? "#ec008c" : "inherit" }} className={`${activeTab === "1" ? "active" : ""} fw-bold`}>All</NavLink>
                        </NavItem> */}
            <NavItem
              className="cursor-pointer"
              onClick={() => {
                setActiveTab("1");
              }}
            >
              <NavLink
                style={{
                  color: activeTab !== "1" ? "#ec008c" : "inherit",
                  fontSize: "90%",
                }}
                className={`${activeTab === "1" ? "active" : ""} fw-bold`}
              >
                Pending({totalItems.pending})
              </NavLink>
            </NavItem>
            <NavItem
              className="cursor-pointer"
              onClick={() => {
                setActiveTab("2");
              }}
            >
              <NavLink
                style={{
                  color: activeTab !== "2" ? "#ec008c" : "inherit",
                  fontSize: "90%",
                }}
                className={`${activeTab === "2" ? "active" : ""} fw-bold`}
              >
                Approved({totalItems.approved})
              </NavLink>
            </NavItem>
            <NavItem
              className="cursor-pointer"
              onClick={() => {
                setActiveTab("3");
              }}
            >
              <NavLink
                style={{
                  color: activeTab !== "3" ? "#ec008c" : "inherit",
                  fontSize: "90%",
                }}
                className={`${activeTab === "3" ? "active" : ""} fw-bold`}
              >
                Rejected({totalItems.rejected})
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            {/* <TabPane tabId="1" className='py-3'>
                            <AllProducts isAdded={isProductAdded} searchId='search-1' uploadedImages={uploadedImages} cityOption={cityOption} categoryOption={categoryOption} url='my-all-products' />
                        </TabPane> */}
            <TabPane tabId="1" className="py-3">
              <AllProducts
                isAdded={isProductAdded}
                onProductEdited={() => {
                  setIsProductAdded(new Date().getTime());
                  setActiveTab("1");
                }}
                searchId="search-3"
                uploadedImages={uploadedImages}
                cityOption={cityOption}
                categoryOption={categoryOption}
                url="my-pending-products"
              />
            </TabPane>
            <TabPane tabId="2" className="py-3">
              <AllProducts
                getTotalItem={(item) => {
                  setTotalItems(item);
                }}
                isApproved={1}
                isAdded={isProductAdded}
                onProductEdited={() => {
                  setIsProductAdded(new Date().getTime());
                  setActiveTab("1");
                }}
                searchId="search-2"
                uploadedImages={uploadedImages}
                cityOption={cityOption}
                categoryOption={categoryOption}
                url="my-approved-products"
              />
            </TabPane>
            <TabPane tabId="3" className="py-3">
              <AllProducts
                isAdded={isProductAdded}
                onProductEdited={() => {
                  setIsProductAdded(new Date().getTime());
                  setActiveTab("1");
                }}
                searchId="search-4"
                uploadedImages={uploadedImages}
                cityOption={cityOption}
                categoryOption={categoryOption}
                url="my-rejected-products"
              />
            </TabPane>
          </TabContent>
        </div>
      </div>
      <AddProduct
        onProductAdded={() => {
          setIsProductAdded(new Date().getTime());
        }}
        uploadedImages={uploadedImages}
        cityOption={cityOption}
        categoryOption={categoryOption}
        isOpen={openAddProduct}
        onClose={() => {
          setOpenAddProduct(false);
        }}
      />
    </div>
  );
};
